import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { t, translate } from "restaumatic-client";
import BarAlert from "./BarAlert";
import CrossSellingBottomSheet from "./CrossSellingBottomSheet";
function ShortForOrderAlert(props) {
    const { bottomSheetId, shortForOrderAlert, onClick } = props;
    const { isVisible, textMessage, crossSellingBottomSheet } = shortForOrderAlert;
    if (!isVisible || textMessage === null) {
        return null;
    }
    const title = shortForOrderAlert.reason === "notEnoughtForOrder"
        ? translate(t.client.cross_selling_bottomsheet.min_order_value.title)
        : translate(t.client.cross_selling_bottomsheet.free_delivery.title);
    const message = shortForOrderAlert.reason === "notEnoughtForOrder"
        ? translate(t.client.cross_selling_bottomsheet.min_order_value.description)
        : translate(t.client.cross_selling_bottomsheet.free_delivery.description);
    return (h(Fragment, null,
        h(BarAlert, { type: textMessage.severity, message: textMessage.message, icon: "info-sign", onClick: onClick }),
        h(CrossSellingBottomSheet, { id: bottomSheetId, title: title, message: message, crossSellingBottomSheet: crossSellingBottomSheet })));
}
export default observer(ShortForOrderAlert);
